import React from "react";
import { Modal, Pressable, ScrollView, StyleSheet } from "react-native";

import ModalHeader from "@/Components/Modals/ModalHeader";
import { Spacings } from "@/styling/spacings";

type Props = {
  title: string;
  modalBody: React.JSX.Element;
  isModalVisible: boolean;
  onRequestClose: () => void;
};

function UnlockUsersBaseModal({
  title,
  modalBody,
  isModalVisible,
  onRequestClose,
}: Props): React.JSX.Element {
  const styles = StyleSheet.create({
    modalOverlay: {
      flex: 1,
      justifyContent: "flex-end",
      backgroundColor: "rgba(0, 0, 0, 0.3)",
    },
    modalContent: {
      padding: Spacings.s4,
      paddingBottom: Spacings.s6,
      borderTopLeftRadius: 20,
      borderTopRightRadius: 20,
      backgroundColor: "#fff",
      maxHeight: "80%",
      flexGrow: 0,
    },
  });

  return (
    <Modal visible={isModalVisible} transparent>
      <Pressable style={styles.modalOverlay} onPress={onRequestClose}>
        <Pressable style={styles.modalContent}>
          <ModalHeader
            title={title}
            onClose={onRequestClose}
            customStyle={{ marginBottom: Spacings.s2 }}
          />
          <ScrollView>{modalBody}</ScrollView>
        </Pressable>
      </Pressable>
    </Modal>
  );
}

export default UnlockUsersBaseModal;
